module.exports = __webpack_public_path__ + "img/analytic_settings_icon.6558e0ec.svg";